<app-modal [dismissible]="false" class="intervention-modal">
    <div class="modal-header" modal-header>
        <h5 class="modal-title">{{ title }}</h5>
    </div>
    <div class="modal-body" modal-body>
        <form [formGroup]="interventionForm">
            <app-textarea [formControl]="interventionForm.controls['description']"
                          formControlName="description"
                          [showErrors]="showValidations"
                          [label]="'intervention-modal.description.label' | translate"
                          [placeholder]="'intervention-modal.description.placeholder' | translate">
            </app-textarea>
            <app-input-switch
                [formControl]="interventionForm.controls['openNewTicket']"
                formControlName="openNewTicket"
                onLabel="{{'generic.yes' | translate}}"
                offLabel="{{'generic.no' | translate}}"
                [topLabel]="'intervention-modal.switch.label' | translate">
            </app-input-switch>
            <app-file-input #fileInput
                            [acceptedTypes]="'.doc,.pdf,.docx,.xlx,.xlxs,.step,.dwg,image/*'"
                            [required]="false"
                            (onFileUpload)="selectFiles($event)"
                            (onFilesSelected)="selectFiles($event)"
                            (onFileRemoved)="selectFiles($event)">
            </app-file-input>
        </form>
    </div>
    <div class="modal-footer" modal-footer>
        <app-button type="simple"
                    (clicked)="onCancel()"
                    [disabled]="isConfirmationInProgress"
                    data-dismiss="modal">{{ "generic.buttons.close" | translate }}
        </app-button>
        <app-button type="primary"
                    (clicked)="onConfirm($event)"
                    data-dismiss="modal">{{ "generic.buttons.confirm" | translate }}
        </app-button>
    </div>
</app-modal>
